import {Component, OnInit, ViewChild} from '@angular/core';

import {Router} from "@angular/router";
import {Property} from "../../../model/property";
import {Document} from "../../../model/document";
import {PropertyFormComponent} from "../../new-order/property-form/property-form.component";
import {AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {PlatformProfile} from "../../../model/platformprofile";
import FormUtils from "../../../utils/form-utils";
import {LoginIdService} from "../../../service/login-id.service";
import {OrderService} from "../../../service/order.service";

@Component({
  selector: 'app-owner-research',
  templateUrl: './owner-research.component.html',
  styleUrls: ['./owner-research.component.css']
})
export class OwnerResearchComponent implements OnInit {


  platformProfile: PlatformProfile;
  @ViewChild(PropertyFormComponent) propertyFormComponent: PropertyFormComponent;

  anliegenForm: UntypedFormGroup;
  dataPrivacyForm: UntypedFormGroup;
  procurementType: string = "Standard";
  legitimateInterest = '';
  interessenOptionen = [
    {name: 'Kaufinteresse', value: 'Kaufinteresse'},
    {name: 'Mietinteresse', value: 'Mietinteresse'},
    {name: 'Sonstiges', value: 'Sonstiges'}
  ];
  properties: Property[];
  property: Property;
  otherHintForm: UntypedFormGroup;
  maxInfoInput: number = 1000;

  constructor(private router: Router,
              private formBuilder: UntypedFormBuilder,
              private loginIdService: LoginIdService,
              // only to prevent error in order-summary-component
              private orderService: OrderService) {

  }

  async ngOnInit(): Promise<void> {

    this.platformProfile = sessionStorage.getItem('platform') ? JSON.parse(sessionStorage.getItem('platform')) : null;
    this.properties = sessionStorage.getItem('new_order_owner_research_properties') ? JSON.parse(sessionStorage.getItem('new_order_owner_research_properties')) : [new Property()];
    if(this.properties.length === 0) {
      this.properties = [new Property()];
    }
    this.property = this.properties[0];

    this.initForms();

    await this.loginIdService.loginServiceInitialized$.toPromise();
  }


  initForms() {

    this.procurementType = this.property?.documents?.[0]?.docname === 'ownrex' ? 'Express' : 'Standard';

    this.dataPrivacyForm = this.formBuilder.group({
      dataPrivacy: new UntypedFormControl(false, Validators.requiredTrue)
    });

    this.otherHintForm = this.formBuilder.group({
      additionalInfo: new UntypedFormControl(sessionStorage.getItem('legitimate_interest') ? JSON.parse(sessionStorage.getItem('legitimate_interest')) : '', Validators.maxLength(this.maxInfoInput)),
    })

    this.anliegenForm = new UntypedFormGroup({
      anliegenType: new UntypedFormControl(((this.property?.documents?.[0]?.information === "Kaufinteresse") || ((this.property?.documents?.[0]?.information === "Mietinteresse"))) ? (this.property?.documents[0]?.information) : (!!this.property?.documents?.[0]?.information ? 'Sonstiges' : ''), Validators.required),
      sonstigesDetails: new UntypedFormControl({
        value: ((this.property?.documents?.[0]?.information !== "Kaufinteresse") && (this.property?.documents?.[0]?.information !== "Mietinteresse")) ? this.property?.documents?.[0]?.information : '',
        disabled: false
      })
    });


    this.anliegenForm.valueChanges.subscribe(values => {
      if (values.anliegenType === 'Sonstiges') {
        this.legitimateInterest = values.sonstigesDetails || '';
      } else {
        this.legitimateInterest = values.anliegenType;
      }
    });

    this.anliegenForm.get('anliegenType').valueChanges.subscribe(value => {
      const sonstigesDetails = this.anliegenForm.get('sonstigesDetails');
      if (value === 'Sonstiges') {
        this.legitimateInterest = '';
        sonstigesDetails.setValidators(Validators.required);
        sonstigesDetails.enable();
      } else {
        sonstigesDetails.clearValidators();
        sonstigesDetails.disable();
      }
      sonstigesDetails.updateValueAndValidity();
    });

  }

  orderSummery() : void {

    // this two calls are to revalidate the forms
    this.anliegenForm.get('anliegenType').setValue(this.anliegenForm.get('anliegenType').value);
    this.propertyFormComponent.propertyForm.get('dataResearch').setValue(this.propertyFormComponent.propertyForm.get('dataResearch').value);

    if (this.anliegenForm.valid && this.propertyFormComponent.propertyForm.valid && this.dataPrivacyForm.valid) {
      this.property = this.propertyFormComponent.propertyForm.value;
      this.property.documents = [new Document(this.procurementType === 'Standard' ? 'ownre' : 'ownrex', this.legitimateInterest)];
      this.properties = [this.property];
      this.storeInSession();
      this.router.navigate(["/cart"], {queryParams: {'owner-research': 'true'}}).then();

    } else {

      FormUtils.markInvalidInputs(this.propertyFormComponent.propertyForm);
      FormUtils.markInvalidInputs(this.propertyFormComponent.ownerForm);
      FormUtils.markInvalidInputs(this.anliegenForm);
      FormUtils.markInvalidInputs(this.dataPrivacyForm);

      scrollTo(0, 0);
    }
  }

  storeInSession(): void {
    sessionStorage.setItem("legitimate_interest", JSON.stringify(this.otherHintForm.value.additionalInfo));
    sessionStorage.setItem("new_order_owner_research_properties", JSON.stringify(this.properties));
  }


  hasError(control: AbstractControl): boolean {
    return (control?.invalid && (control?.touched));
  }

  back() {
    this.router.navigate(["/"]).then();
  }

  // stop propagation and prevent default to avoid the click event on the parent element and navigate to the url ( AGB || Datenschutz)
  navigateTo($event: MouseEvent, url: string) {
    $event.preventDefault();
    $event.stopPropagation();
    window.open(url, '_blank');
  }
}
